import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/home/global'

export const ORDERS_HOME_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
